export class BattenDivision {
	public static NONE: number = 0;
	public static BATTEN: number = 1;
	public static PLANKING: number = 2;
}